import {
    CREATE_WORKER_JAMA,
    DELETE_WORKER_JAMA,
    GET_WORKER_JAMA,
    WORKER_JAMA_REQUEST,
    WORKER_JAMA_REQUEST_FAILURE,
    UPDATE_WORKER_JAMA,
    JAMA_KARIGAR_REQUEST,
    GET_JAMA_KARIGARS,
    JAMA_KARIGAR_REQUEST_FAILURE
  } from "../types/worker-jama-types";
  
  const initialState = {
    workerJama: [],
    karigarWorkers: [],
    loading: false,
    error: null,
  };

  const workerJamaReducer = (state = initialState, action) => {
    switch (action.type) {
      case WORKER_JAMA_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case JAMA_KARIGAR_REQUEST: {
          return {
            ...state,
            karigarWorkers: [],
            loading: true,
            error: null
          }
        }
      case GET_WORKER_JAMA: {
        return {
          ...state,
          workerJama: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_JAMA_KARIGARS: {
        return {
          ...state,
          karigarWorkers: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_WORKER_JAMA:
        return {
          ...state,
          workerJama: [action.payload, ...state.workerJama],
          loading: false,
          error: null
        };
      case UPDATE_WORKER_JAMA:
        const workerJamaData = state.workerJama.slice(0);
        console.log('before>>', workerJamaData);
        const uIndex = workerJamaData.findIndex((data) => data.id === action.payload.id);
        console.log('uIndex>>', uIndex);
        workerJamaData.splice(uIndex, 1, { ...action.payload.data });
        console.log('after>>', workerJamaData.splice(uIndex, 1, { ...action.payload.data }));
        
        return {
          ...state,
          workerJama: [ ...workerJamaData ],
          loading: false,
          error: null
        };
      case DELETE_WORKER_JAMA:
        const workerJama = state.workerJama?.slice(0);
        const index = workerJama.findIndex((data) => data.id === action.id);
        if (index > -1) {
          workerJama.splice(index, 1);
        }
        return {
          ...state,
          workerJama: [...workerJama],
          loading: false,
          error: null
        }
      case WORKER_JAMA_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case JAMA_KARIGAR_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };

  export default workerJamaReducer;
  